import { LawyerPosition, OtherData } from "@/interfaces/types";


export const OTHERDATAACTIONS = {
};

export function otherDataReducer(state: typeof initialOtherState, action: any) {
    switch (action.type) {
        default:
            return {
                ...state,
                [action.field]: action.value,
            };
    }
}

export const initialOtherState: OtherData = {
    allLawyers: [],
    expertise: [
        'Any',
        'Energy',
        'Intellectual Property',
        'Food Law',
        'Italian Desk',
        'Life Sciences',
        'Banking & Finance',
        'Environment & Climate Changes',
        // Add more expertise areas as needed
    ] as string[],
    seniority: ['Partner', 'Counsel', 'Senior Associate', 'Associate', 'Junior Associate', 'Paralegal'] as string[],
    lawyerPositions: {} as Record<string, LawyerPosition>,
};
